var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mx-element',{attrs:{"type":"ChildPageTitle","title":_vm.Title,"hide":_vm.FullScreen}},[(_vm.Name)?_c('mx-page',{key:_vm.timespan,attrs:{"type":"Home","config":_vm.detail,"parent":_vm.parent,"is-child":_vm.isChild,"name":_vm.Name,"theme":"List"},on:{"meta-change":_vm.OnMetaChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }